

import templateModal from '@/app-template/lib/components/BookingModal.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BookingModal',
  components: { templateModal },
});
